let load_more = false;
$(window).scroll(function () {
	let button = $("#ajax_next_page");
	if (button.length && !load_more) {
		let url = button.data("href") + '&ajaxMode=y';
		let offset_button = button.offset();
		let block = button.parents('.js-items-block')
		if ($(this).scrollTop() >= offset_button.top - $(window).height()) {
			load_more = true;
			$.ajax({
				url: url,
				type: "GET",
				data: {IS_AJAX: 'Y'},
				cache: true,
				success: function (data) {
					block.append($(data).html());
					button.remove();
					load_more = false;
				}
			});
		}
	}
});